export default "__VITE_ASSET__D0VEhq0o__"